import { render, staticRenderFns } from "./contextualize-service-audit-details.component.vue?vue&type=template&id=56267da3&scoped=true"
import script from "./contextualize-service-audit-details.component.vue?vue&type=script&lang=ts"
export * from "./contextualize-service-audit-details.component.vue?vue&type=script&lang=ts"
import style0 from "./contextualize-service-audit-details.component.vue?vue&type=style&index=0&id=56267da3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56267da3",
  null
  
)

export default component.exports